import React from "react";
import SectionAbout from "../../../components/LandingPage/HomeSection/SectionAbout";
import SectionBanner from "../../../components/LandingPage/HomeSection/SectionBanner";
import SectionProjectKami from "../../../components/LandingPage/HomeSection/SectionProjectKami";
import SectionKenapaKami from "../../../components/LandingPage/HomeSection/SectionKenapaKami";
import SectionLayanan from "../../../components/LandingPage/HomeSection/SectionLayanan";
import SectionPartnerKlienKami from "../../../components/LandingPage/HomeSection/SectionPartnerKlienKami";
import SectionBlog from "../../../components/LandingPage/HomeSection/SectionBlog";
import SectionContactUs from "../../../components/LandingPage/HomeSection/SectionContactUs";
import TabTitle from "../../../utils/TabTitle";

const HomePage = () => {
  TabTitle("Beranda - Satu Langkah");
  return (
    <>
      <SectionBanner />
      <SectionAbout />
      <SectionProjectKami />
      <SectionKenapaKami />
      <SectionLayanan />
      <SectionPartnerKlienKami />
      <SectionBlog />
      <SectionContactUs />
    </>
  );
};

export default HomePage;
